import { useTranslations } from 'next-intl';
import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron16.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';
import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './GroupItems.styles';

export interface GroupItemsProps {
  children?: React.ReactNode;
  groupType?: number | null;
  data?: MappedProduct[];
}

export function GroupItems({ children, groupType, data }: GroupItemsProps) {
  const t = useTranslations();
  const slots = styles();

  const [isCollapse, setIsCollapse] = useState(true);

  if (!data?.length) return null;

  const getGroupTypeName = () => {
    switch (String(groupType)) {
      case '1':
        return t('careProgram');
      case '2':
        return t('virtualGroup');
      default:
        return t('compositionGroup');
    }
  };

  return (
    <div className={slots.base()}>
      <UiKitButtonBase
        className={slots.collapseButton()}
        color="ghost"
        onClick={() => setIsCollapse((s) => !s)}
      >
        {getGroupTypeName()}
        <ChevronIcon
          className={slots.collapseArrow({ collapse: isCollapse })}
        />
      </UiKitButtonBase>
      <UiKitCollapseBase collapse={isCollapse}>
        <div className={slots.itemsGroup()}>{children}</div>
      </UiKitCollapseBase>
    </div>
  );
}
